import apiSlice from './apiSlice';

export interface AdminProfile {
  id: number;
  firstname: string;
  lastname: string;
  email: string;
  profileImage: string | null;
  status: string;
  createdAt: string;
  updatedAt: string;
}

export interface UpdateProfilePayload {
  firstname?: string;
  lastname?: string;
  email?: string;
}

export interface ChangePasswordPayload {
  oldPassword: string;
  newPassword: string;
}

export const profileApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({

    getAdminProfile: builder.query<AdminProfile, void>({
      query: () => ({
        url: '/admin',
        method: 'GET',
      }),
      providesTags: ['AdminProfile'],
    }),

    updateAdminProfile: builder.mutation<AdminProfile, UpdateProfilePayload>({
      query: (body) => ({
        url: '/admin',
        method: 'PATCH',
        body,
      }),
      invalidatesTags: ['AdminProfile'],
    }),


    uploadProfileImage: builder.mutation<
  { profileImage: string },
  { profileImage: string }
>({
  query: (body) => ({
    url: '/admin/profile-image',
    method: 'POST',
    body,
  }),
  invalidatesTags: ['AdminProfile'],
}),

    changePassword: builder.mutation<
      { message: string },
      ChangePasswordPayload
    >({
      query: (body) => ({
        url: '/admin/change-password',
        method: 'POST',
        body,
      }),
    }),
  }),
});

export const {
  useGetAdminProfileQuery,
  useUpdateAdminProfileMutation,
  useUploadProfileImageMutation,
  useChangePasswordMutation,
} = profileApi;